@if (!isListTemplate && !isMultiMarketTemplate) {
    <!-- Sport Card -->
    @if (!(isOutrightsCard && isEnhancedMultiplesCard && isSpecialCard)) {
        <odds-card-sport
            [event]="event"
            [vnSpeculativeLink]="goToEvent(true)"
            [eventStartedOrLive]="isLive"
            [sportType]="sportType"
            [eventQuickSwitch]="eventQuickSwitch"
            [sportConfig]="sportConfig"
            [selectedMarketObject]="selectedMarketObject"
            [selectedMarket]="selectedMarket"
            [featured]="featured"
            [isFilterByTemplateMarketName]="isFilterByTemplateMarketName"
            [eventType]="eventType"
            [widget]="widget"
            [gtmModuleTitle]="gtmModuleTitle"
            (goToEventCallback)="callGoToEventCallback()"
            (marketUndisplayed)="changeCardView($event)"
            [isFootballCoupon]="isFootballCoupon"
            [statsFilter]="statsFilter"
            [isCoralMobile]="isCoralMobile"
            [isFHPI]="isFHPI"
            [isIP]="isIP"
            [isHP]="isHP"
            [isHomePage]="isHomePage">
        </odds-card-sport>
    }

    <!--coupon stat widget -->
    @for (market of event.markets; track market.id) {
        @if (isFootballCoupon && !isOutrightsCard && event.isShowStatsEnabled && eventDisplayed(market) && !market.hidden && isSportCard(market)) {
            <div class="show-hide-stats" (click)="onExpand()">
                @if (showBoard) {
                    <span class="hide-stats" [i18n]="'HIDE STATS'"></span>
                    <svg>
                        <use xlink:href="#up-arrow"></use>
                    </svg>
                } @else {
                    <span class="show-stats" [i18n]="'SHOW STATS'"></span>
                    <svg>
                        <use xlink:href="#down-arrow"></use>
                    </svg>
                }
            </div>
        }
    }

    <div class="coupon-stat">
        @if (showBoard && isFootballCoupon) {
            <lazy-component
                moduleUri="@lazy-modules-module/coupon-stat-widget/coupon-stat-widget.module#CouponStatWidgetModule"
                [inputs]="{ couponIndex: couponIndex, eventIndex: eventIndex, dateIndex: dateIndex, event: event }"
                entryComponent="CouponStatWidgetComponent">
            </lazy-component>
        }
    </div>

    <!-- Outrights -->
    @if (isOutrightsCard) {
        <list-card
            [item]="event"
            [link]="goToEvent(true, '')"
            [title]="eventName"
            [vnSpeculativeLink]="goToEvent(true)"
            (clickFunction)="goToEvent(false, $event); goToSeo()"
            (goToEventCallback)="callGoToEventCallback()"
            [attr.data-eventid]="event.id"
            [gtmModuleTitle]="gtmModuleTitle"
            class="sticky-virtual-scroll-item"
            data-crlat="oddsCard.outrightsTemplate"
            [ngClass]="event.isShowStatsEnabled ? 'removeBorderBottom' : ''">
            @if (eventStartedOrLive && !isIP && !isHP && !isFHPI) {
                <div class="live-card-label">
                    <live-label data-crlat="liveLabel"></live-label>
                </div>
            }
        </list-card>
    }

    <!-- Enhanced Multiples Card-->
    @if (isEnhancedMultiplesCard) {
        <odds-card-enhanced
            [vnSpeculativeLink]="goToEvent(true)"
            [attr.data-eventid]="event.id"
            [event]="event"
            [limitSelections]="limitSelections"
            data-crlat="oddsCard.enhancedMultiplesTemplate"
            [gtmModuleTitle]="gtmModuleTitle"
            (goToEventCallback)="callGoToEventCallback()">
        </odds-card-enhanced>
    }

    <!--Specials Card-->
    @if (isSpecialCard) {
        <lazy-component
            [vnSpeculativeLink]="goToEvent(true)"
            moduleUri="@lazy-modules-module/oddsCardSpecialsLazy/odds-card-specials-lazy.module#OddsCardSpecialsLazyModule"
            data-crlat="oddsCard.specialsTemplate"
            [inputs]="{ gtmModuleTitle: gtmModuleTitle, event: event, changeStrategy: 'onPush' }"
            (goToEventCallback)="callGoToEventCallback()"
            entryComponent="OddsCardSpecialsComponent">
        </lazy-component>
        <!-- <odds-card-specials 
                        [event]="event"
                        data-crlat="oddsCard.specialsTemplate"
                        [gtmModuleTitle]="gtmModuleTitle"
                        (goToEventCallback)="callGoToEventCallback()"></odds-card-specials> -->
    }
}

@if (isListTemplate) {
    <!-- List template -->
    <lazy-component
        [vnSpeculativeLink]="goToEvent(true)"
        moduleUri="@lazy-modules-module/listTemplate/list-template.module#ListTemplateModule"
        [inputs]="{
            event: event,
            eventStartedOrLive: eventStartedOrLive,
            sportType: sportType,
            sportConfig: sportConfig,
            selectedMarketObject: selectedMarketObject,
            selectedMarket: selectedMarket,
            featured: featured,
            isFilterByTemplateMarketName: isFilterByTemplateMarketName,
            eventType: eventType,
            widget: widget,
            gtmModuleTitle: gtmModuleTitle,
            isIP: isIP,
        }"
        (goToEventCallback)="callGoToEventCallback()"
        (marketUndisplayed)="changeCardView($event)"
        entryComponent="ListTemplateComponent">
    </lazy-component>
}

@if (isMultiMarketTemplate) {
    <!-- List template -->
    <lazy-component
        [vnSpeculativeLink]="goToEvent(true)"
        moduleUri="@lazy-modules-module/multiMarketTemplate/multi-market-template.module#MultiMarketTemplateModule"
        [inputs]="{
            event: event,
            eventStartedOrLive: eventStartedOrLive,
            sportType: sportType,
            sportConfig: sportConfig,
            selectedMarketObject: selectedMarketObject,
            selectedMarket: selectedMarket,
            featured: featured,
            isFilterByTemplateMarketName: isFilterByTemplateMarketName,
            isCoralMobile: isCoralMobile,
            isIP: isIP,
            eventType: eventType,
            widget: widget,
            gtmModuleTitle: gtmModuleTitle,
        }"
        [outputs]="['goToEventCallback', 'marketUndisplayed']"
        (event)="handleOutput($event)"
        entryComponent="MultiMarketTemplateComponent">
    </lazy-component>
}

<!--inplay stat widget -->
<div class="inplay-stat">
    @if (event.isShowStatsEnabled && inPlay) {
        <lazy-component
            moduleUri="@lazy-modules-module/inplay-stat-widget/inplay-stat-widget.module#InplayStatWidgetModule"
            [inputs]="{ maxwidgets: this.leagueIds?.InplayStatsWidgetMax?.MAX_INPLAY_WIDGETS, event: event, changeStrategy: 'onPush' }"
            entryComponent="InplayStatWidgetComponent">
        </lazy-component>
    }
</div>
